import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/localpriority",

        async search(showAnunciante) {
            const url = this.userUrl({
                path: `/level?showAnunciante=${showAnunciante}`
            });

            return Vue.http.get(url);
        },

        async alterLabel({ label, level }) {
            const url = this.userUrl({
                path: `/level/${level}/label`
            });

            return Vue.http.put(url, label, {
                headers: { "Content-Type": "text/plain" }
            });
        },

        async alterPriority({ priorityArray }) {
            const url = this.userUrl({ path: `/` });

            return Vue.http.put(url, priorityArray);
        }
    },
    base
);
